<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";

  label {
    all: unset;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    .label-text {
      display: flex;
      flex-direction: row;
      gap: 6px;
      padding: 0 utils.in_rem(4px) utils.in_rem(6px) utils.in_rem(4px);

      &.large {
        @include mixins.h4();
      }

      &.small {
        @include mixins.caption();
      }
    }

    .content {
      display: flex;
      flex-direction: row;
      width: 100%;

      > input {
        @include colors.color(textBlack);
        @include mixins.body2();
        width: 100%;
        padding: utils.in_rem(4px) utils.in_rem(4px) utils.in_rem(4px)
          utils.in_rem(12px);
        height: utils.in_rem(44px);
        border: 1.5px solid colors.get(interfaceSwGrey_10);
        border-radius: 10px;

        &:not(:disabled):hover {
          border: 1.5px solid colors.get(primary_10);
        }

        &:focus {
          outline: 0;
          border: 1.5px solid colors.get(primary_40);
        }
        &.error {
          border: 1.5px solid colors.get(systemError_100);
        }
        &.warning {
          border: 1.5px solid colors.get(systemWarning_100);
        }

        &.xsmall {
          @include mixins.body3();
          height: utils.in_rem(32px);
          padding: utils.in_rem(4px) utils.in_rem(8px);
          border-radius: 8px;
        }
        &.small {
          height: utils.in_rem(36px);
          border-radius: 8px;
        }
        &.large {
          height: utils.in_rem(48px);
        }
      }
    }

    .helper-text {
      display: flex;
      flex-direction: row;
      gap: utils.in_rem(4px);
      padding: utils.in_rem(6px) utils.in_rem(4px) 0 utils.in_rem(4px);
      color: colors.get(textGrey);
      @include mixins.caption();

      &.error {
        color: colors.get(systemError_100);
      }
      &.warning {
        color: colors.get(systemWarning_100);
      }
    }
  }
</style>

<script>
  import IconScale from "../../atoms/IconScale.svelte";

  let cls = "";
  export { cls as class };
  export let size = "";
  export let label = "";
  export let labelSize = "small";
  export let helperText = "";
  export let style = "";
  export let state = "";

  export let min = 0;
  export let max = null;
  export let step = 1;
  export let value = 0;
  export let disabled = false;
  export let placeholder = "";
  export let allowEmptyState = false;

  $: {
    if (value < min) value = min;
    if (max !== null && value > max) value = max;
  }

  const handleChange = (e) => {
    const inputValue = e.target.value;

    if (allowEmptyState && ["", null, undefined].includes(inputValue)) {
      value = null;
      return;
    }

    e.target.value = +inputValue.toString();
    value = +inputValue;
  };
</script>

<label class={cls} {style}>
  {#if label}
    <div class="label-text {labelSize}">
      <span>{label}</span>
      {#if $$slots.tooltip}
        <IconScale class="fa-circle-info" size="xs" placement="top">
          <span slot="tooltip"><slot name="tooltip" /></span>
        </IconScale>
      {/if}
    </div>
  {/if}
  <div class="content">
    <input
      class="{state} {size}"
      type="number"
      bind:value
      {max}
      {min}
      {step}
      {disabled}
      {placeholder}
      on:input={handleChange}
    />
  </div>
  {#if helperText}
    <span class="helper-text {state}">
      {#if ["error", "warning"].includes(state)}
        <IconScale class="fa-solid fa-circle-info" size="xs" />
      {/if}
      {helperText}
    </span>
  {/if}
</label>
